<template>
  <svg class="app-loader" viewBox="150 80 181 201" aria-hidden="true">
    <g>
      <rect x="186" y="80" width="9" height="30" rx="4.5"/>
      <rect x="286" y="80" width="9" height="30" rx="4.5"/>
      <path d="M150 116a16 16 0 0 1 16-16h149a16 16 0 0 1 16 16v27H150z"/>
      <rect x="155.5" y="105.5" width="170" height="170" rx="10.5" fill="none" stroke="currentColor" stroke-width="11"/>
      <circle cx="178.5" cy="194.5" r="6.5"/>
      <circle cx="209.5" cy="194.5" r="6.5"/>
      <circle cx="240.5" cy="194.5" r="6.5"/>
      <circle cx="271.5" cy="194.5" r="6.5"/>
      <circle cx="302.5" cy="194.5" r="6.5"/>
      <circle cx="178.5" cy="220.5" r="6.5"/>
      <circle cx="209.5" cy="220.5" r="6.5"/>
      <circle cx="240.5" cy="220.5" r="6.5"/>
      <circle cx="271.5" cy="220.5" r="6.5"/>
      <circle cx="302.5" cy="220.5" r="6.5"/>
    </g>
    <g class="pulse-row">
      <circle cx="178.5" cy="168.5" r="6.5"/>
      <circle cx="209.5" cy="168.5" r="6.5"/>
      <circle cx="240.5" cy="168.5" r="6.5"/>
      <circle cx="271.5" cy="168.5" r="6.5"/>
      <circle cx="302.5" cy="168.5" r="6.5"/>
    </g>
  </svg>
</template>

<script lang="ts">
import { Vue } from 'vue-class-component'

export default class AppLoader extends Vue {}
</script>

<style lang="scss" scoped>
// The practice theme rewrites --text-color, so the loader reads its own palette
// tokens, which the theme never touches.
.app-loader {
  width: 56px;
  height: auto;
  color: var(--loader-ink);
  fill: currentColor;
}

// One dot lights up every 1.44s and fades out over the next 3.2s,
// so the five of them complete a 7.2s cycle.
.pulse-row circle {
  opacity: 0;
  animation: app-loader-pulse 7.2s linear infinite;

  &:nth-child(2) {
    animation-delay: -5.76s;
  }
  &:nth-child(3) {
    animation-delay: -4.32s;
  }
  &:nth-child(4) {
    animation-delay: -2.88s;
  }
  &:nth-child(5) {
    animation-delay: -1.44s;
  }
}

@keyframes app-loader-pulse {
  0% {
    fill: var(--loader-accent);
    opacity: 1;
  }
  7.8% {
    fill: var(--loader-ink);
    opacity: 0.61;
  }
  18.9% {
    opacity: 0.35;
  }
  30% {
    opacity: 0.15;
  }
  37.8% {
    opacity: 0.06;
  }
  44.4%,
  100% {
    opacity: 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .pulse-row circle {
    animation: none;
    fill: var(--loader-accent);
    opacity: 0.61;
  }
}
</style>
